var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel-section'),_c('about-section'),_c('icon-description-section'),_c('innovative-features-section'),_c('store-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }